import Device from '../../../../../../../constants/deviceSizes';

export default {
  container: {
    height: '100%',
    width: '100%',
    textAlign: 'justify'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'row',
    alignItems: 'center'
  },
  button: {
    padding: 10
  },
  debtDescContainer: {
    width: '60%',
    [Device.mobile]: {
      width: '100%'
    }
  },
  table: {
    padding: '10px 40px 25px 0px',
    [Device.mobile]: {
      padding: '10px 0px 25px'
    }
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '25px 40px',
    boxSizing: 'border-box',
    [Device.mobile]: {
      padding: 10
    }
  }
};
